import styles from './close-button.module.css';
import { Icon } from '../index';
import { Icons } from '../Icon/Icon';

interface CloseButtonProps {
    onClick?: any;
    el?: string;
}

const CloseButtonRounded = ({ onClick, el = 'button' }: CloseButtonProps) => {
    const Tag = el;

    return (
        // @ts-expect-error types
        <Tag type={'button'} className={styles.close} onClick={onClick}>
            <Icon icon={Icons.close} />
        </Tag>
    );
};

export default CloseButtonRounded;
